<script lang="ts">
	import { push } from '../../svelte-spa-router';
	import type { PublicService } from '../../AppTypes';
	import { statusLabel, statusText, statusBg } from '../../statusUtils';

	export let service: PublicService;
</script>

<button
	class="w-full text-left py-3 px-4 flex items-center justify-between hover:bg-gray-50 dark:hover:bg-zinc-800/60 transition rounded-lg"
	on:click={() => push(`/Service/${service.slug}`)}
>
	<div class="flex items-center gap-3 min-w-0">
		<span class="inline-block w-2.5 h-2.5 rounded-full shrink-0 {statusBg(service.status)}"></span>
		<div class="min-w-0">
			<p class="font-medium text-gray-900 dark:text-white truncate">{service.name}</p>
			{#if service.description}
				<p class="text-xs text-gray-500 dark:text-gray-400 truncate">{service.description}</p>
			{/if}
		</div>
	</div>
	<div class="flex items-center gap-4 shrink-0">
		{#if service.uptime90d !== null}
			<span class="text-xs text-gray-400 hidden sm:inline">{service.uptime90d}% uptime</span>
		{/if}
		<span class="text-sm font-medium {statusText(service.status)}">{statusLabel(service.status)}</span>
	</div>
</button>
